import { Pipe, PipeTransform } from '@angular/core';

const lastLocationTypes: Record<string, string> = {
  driver_waypoint: 'Driver Waypoint',
  site_location: 'Site Location',
  asset_waypoint: 'Asset Waypoint',
};

@Pipe({
  name: 'lastLocationType',
})
export class LastLocationTypePipe implements PipeTransform {
  public transform(value: string): string {
    return lastLocationTypes[value];
  }
}
